import React from 'react';
import "../../../assets/css/master.css"
import AccesspointmasterRailway from './Partial/AccesspointmasterRailway';
import AccesspointmasterAirport from './Partial/AccesspointmasterAirport';
import AccesspointmasterPort from './Partial/AccesspointmasterPort';
import AccesspointmasterBus from './Partial/AccesspointmasterBus';
import AccesspointmasterOtherPoints from './Partial/AccesspointmasterOtherPoints';

const Accesspointmaster = () => {
    return (
        <>
            <div class="container-fluid mt-4 heading_color">
                <h3>Access Point Master</h3>
            </div>
            <div className='container-fluid mt-3 tab_section px-0'>
                <ul class="nav nav-pills nav-justified mb-3 pt-3" id="pills-tab" role="tablist">
                    <li class="nav-item mx-lg-1 mx-md-1 mx-1 mt-1" role="presentation">
                        <button class="nav-link active h-100" id="pills-Bus-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-Bus" type="button" role="tab" aria-controls="pills-Bus"
                            aria-selected="true"><strong>Bus Stand</strong></button>
                    </li>
                    <li class="nav-item mx-lg-1 mx-md-1 mx-1  mt-1" role="presentation" >
                        <button class="nav-link h-100" id="pills-Railway-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-Railway" type="button" role="tab" aria-controls="pills-Railway"
                            aria-selected="false"><strong >Railway Station</strong></button>
                    </li>
                    <li class="nav-item mx-lg-1 mx-md-1 mx-1  mt-1" role="presentation" >
                        <button class="nav-link h-100" id="pills-Airport-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-Airport" type="button" role="tab" aria-controls="pills-Airport"
                            aria-selected="false"><strong >Airport</strong></button>
                    </li>
                    <li class="nav-item mx-lg-1 mx-md-1 mx-1  mt-1" role="presentation" >
                        <button class="nav-link h-100" id="pills-Port-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-Port" type="button" role="tab" aria-controls="pills-Port"
                            aria-selected="false"><strong >Port</strong></button>
                    </li>
                    <li class="nav-item mx-lg-1 mx-md-1 mx-1  mt-1" role="presentation" >
                        <button class="nav-link h-100" id="pills-OtherPoints-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-OtherPoints" type="button" role="tab" aria-controls="pills-OtherPoints"
                            aria-selected="false"><strong >Other Points</strong></button>
                    </li>
                </ul>
            </div>
            <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" id="pills-Bus" role="tabpanel"
                    aria-labelledby="pills-Bus-tab">
                    <AccesspointmasterBus />
                </div>
                <div class="tab-pane fade show" id="pills-Railway" role="tabpanel"
                    aria-labelledby="pills-Railway-tab">
                    <AccesspointmasterRailway />
                </div>
                <div class="tab-pane fade show" id="pills-Airport" role="tabpanel"
                    aria-labelledby="pills-Airport-tab">
                    <AccesspointmasterAirport />
                </div>
                <div class="tab-pane fade show" id="pills-Port" role="tabpanel"
                    aria-labelledby="pills-Port-tab">
                    <AccesspointmasterPort />
                </div>
                <div class="tab-pane fade show" id="pills-OtherPoints" role="tabpanel"
                    aria-labelledby="pills-OtherPoints-tab">
                    <AccesspointmasterOtherPoints />
                </div>
            </div>
        </>
    )
}

export default Accesspointmaster